define.alias("shared/components/shared/badge", "calendar/components/shared/badge");